export type ApiErrorParams = Record<string, unknown> & { count?: number };

function mapErrorParams(params: Record<string, unknown>): ApiErrorParams {
  if (typeof params.attemptsLeft === 'number') {
    return { count: params.attemptsLeft };
  }
  if (typeof params.unlockInSec === 'number') {
    return { count: params.unlockInSec };
  }

  return params;
}

export class ApiError extends Error {
  public readonly params?: ApiErrorParams;

  constructor(
    message: string,
    public readonly status: number,
    name?: string,
    params?: Record<string, unknown>,
  ) {
    super(message);
    if (name) {
      this.name = name;
    }
    if (params) {
      this.params = mapErrorParams(params);
    }
  }
}
